import * as React from 'react'
import { useRoutes } from 'react-router-dom'

import RootLayout from './Components/Templates/layout/RootLayout'
import routes from './Routes'

function App() {
  const routing = useRoutes(routes)
  return <RootLayout>{routing}</RootLayout>
}

export default App
